import { useMemo } from 'react'
import { useAppSelector } from 'store/configureStore'

export const useQuotationExchangeInvalidation = () => {
  const payload = useAppSelector(
    (state) => state.quotationExchange.invalidation,
  )
  const sequence = useAppSelector(
    (state) => state.quotationExchange.invalidationSequence,
  )

  return useMemo(() => ({ payload, sequence }), [payload, sequence])
}

export const matchesQuotationExchangeInvalidation = (
  payload: ReturnType<typeof useQuotationExchangeInvalidation>['payload'],
  values: { projectId?: string; requestForQuotationId?: string },
) => {
  if (!payload) return false
  if (values.projectId && payload.projectId && payload.projectId !== values.projectId)
    return false
  if (
    values.requestForQuotationId &&
    payload.kind === 'rfq' &&
    payload.itemId !== values.requestForQuotationId
  )
    return false
  return true
}
